import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ResetPasswordComponent } from './reset-password/reset-password.component';

import { AuthResolver } from '../shared/services/auth.resolver';
import { config } from "../../../config/index";

const appRoutes: Routes = [
    { path: 'reset-password/:token', component: ResetPasswordComponent }
];


@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes)
    ],
    exports: [
        RouterModule
    ]
})

export class PatientAppViewRoutingModule { }
